import { render, staticRenderFns } from "./ZodiacSignResultView.vue?vue&type=template&id=c2353b76&scoped=true&"
import script from "./ZodiacSignResultView.vue?vue&type=script&lang=ts&"
export * from "./ZodiacSignResultView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2353b76",
  null
  
)

export default component.exports